<template>
    <div class="prize">
        <h2>{{ prize.name }}</h2>
        <img :src="prize.imageUrl" :alt="prize.name" :title="prize.name">
    </div>
</template>

<script>
    export default {
        props: {
            prize: Object
        }
    }
</script>

<style lang="scss" scoped>
    .prize {
        width: 200px;
        display: inline-block;
        margin: 10px;

        h2 {
            font-weight: 500;
        }
    }
</style>
